import styled from "styled-components";
import PageSubLinkItem from "./PageSubLinkItem";

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 35px;
  width: calc(100% - 60px);
  margin: 0 30px;
  padding: 30px 0;
  background-color: ${({ theme }) => theme.mainBgColor};
  z-index: 100;
  overflow-x: visible;
  flex-wrap: wrap;
  @media (max-width: 1550px) {
    width: 100%;
    margin: 0;
    padding: 30px;
    gap: 25px;
    a {
      font-size: 14px !important;
    }
  }
`;

const PageSubLinks = ({ subLinks }) => {
  
  return (
    <Container>
      {subLinks.map((item) => (
        <PageSubLinkItem key={item.id} item={item} />
      ))}
    </Container>
  );
};

export default PageSubLinks;
